import HeroSection from "@/components/HeroSection";
import TrustBar from "@/components/TrustBar";
import ServicesGrid from "@/components/ServicesGrid";
import TeamSection from "@/components/TeamSection";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import CTASection from "@/components/CTASection";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <HeroSection />
      <TrustBar />
      <ServicesGrid />
      <TeamSection />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
    </main>
  );
}
